import Login from "view3/Login.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    city: state.city
  };
}

const LoginContainer = connectFunction(mapStateToProps)(Login);
export default LoginContainer;
